import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Link from "next/link";
import {
  Card, CardHeader, CardFooter,
  CardContent, CardTitle
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { validateEmail } from "@/lib/utils";
import { updateAnonEmailApi } from "@/clientSideApi/cart";
import { setEmailValidity, setNotify } from "@/store/cart/cartSlice";

let prevEmailVal = "";

const Contact = () => {

  const dispatch = useDispatch();
  const emailIsValid = useSelector((state) => state.cart.emailIsValid);
  const user_email = useSelector((state) => state.cart.data?.user_email);
  const notify = useSelector((state) => state.cart.data?.notify);
  const user = useSelector((state) => state.general.user);
  const [showEmailInput, setShowEmailInput] = useState(!emailIsValid);
  const [email, setEmail] = useState("");

  if (user && user.token) return null;

  const toggleError = (error) => {
    const anonEmail = document.getElementById('anonEmail');
    const anonEmailLabel = document.getElementById("anonEmailLabel");
    let removeClass = "border-[red]";
    let addClass = "border-slate-300";
    let labelVisibility = "hidden"
    if(error){
      removeClass = "border-slate-300";
      addClass = "border-[red]";
      labelVisibility = "visible"
    }
    anonEmail.classList.remove(removeClass);
    anonEmail.classList.add(addClass);
    anonEmailLabel.style.visibility = labelVisibility;
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    toggleError(false);
  }

  const handleNotifyChange = () => {
    dispatch(setNotify(!notify))
  }

  const validateAnonEmail = (currentEmail) => {
    if (!currentEmail) return false;
    if (!validateEmail(currentEmail)) return false;
    return true;
  };

  const handleFocus = () => {
    toggleError(false);
    prevEmailVal = email;
  }

  const handleBlur = async () => {
    if ((prevEmailVal === email) && !emailIsValid) return;
    if (!validateAnonEmail(email)) {
      toggleError(true);
      return;
    }
    const apiResponse = await updateAnonEmailApi({
      user_email: email,
    });
    const isValid = Boolean(apiResponse)
    dispatch(setEmailValidity(isValid));
    setShowEmailInput(!isValid)
  }

  const toggleEmailEdit = () => {
    setShowEmailInput(prevData => !prevData)
  }

  return (
    <section>
      <Card
        className="
        w-full border-0 overflow-hidden 
        relative sans relative rounded-none 
        py-10 px-6
      "
      >
        <CardHeader className="space-y-0 px-0 py-0 flex flex-row items-center justify-between">
          <CardTitle>CONTACT</CardTitle>
          <h4 className="space-y-0">
            <span className="mr-1">Have an account?</span>
            <Link href="/sign-in" className="underline">
              Login
            </Link>
          </h4>
        </CardHeader>
        <CardContent className="px-0 py-0 mt-3">
          {
            showEmailInput ?
              <input
                id="anonEmail"
                className={`
                  p-2 border text-font-primaryMuted h-[45px] w-full 
                  hover:outline-none rounded-none focus:outline-none
                  placeholder:text-slate-400
                  placeholder:text-sm placeholder:tracking-wide 
                  border-slate-300
                `}
                placeholder="Email"
                type="email"
                value={email}
                onChange={handleEmailChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
              /> :
              <div className="cursor-default px-3 py-2 flex justify-between items-center border border-slate-300 rounded-sm">
                <span className="text-sm tracking-wide">{email || user_email}</span>
                <Button
                  variant="secondary"
                  className="
                      bg-white hover:bg-white rounded-none 
                      px-2 py-0  h-[45px] border-0
                      items-center justify-between cursor-pointer 
                      underline
                  "
                  onClick={toggleEmailEdit}
                >
                  Edit
                </Button>
              </div>

          }
          <span  
            id={'anonEmailLabel'}
            className="invisible text-[red] text-xs h-[20px] overflow-hidden text-ellipsis line-clamp-1"
          >
            Please add a valid email
          </span>
        </CardContent>
        <CardFooter className="px-0 py-0">
          <input
            type="checkbox"
            id="emailSub"
            name="emailSub"
            value={notify}
            onChange={handleNotifyChange}
            className="h-[20px] w-[20px] mr-1 cursor-pointer"
          />
          <span>Email me with news and offers</span>
        </CardFooter>
      </Card>
    </section>
  );
};

export default Contact;
